import { localized } from '@/i18n/localize'
export const connectivityStrings = localized({
  banner: 'No internet connection',
  title: 'No Internet',
  resume: 'Leazepro will resume automatically.',
  offlineFor: (elapsed: string) => `Offline for ${elapsed}`,
})
